import { Card, Heading, Input, Spinner } from '@enterprise-ui/canvas-ui-react'
import { BULK_UPDATE } from '../../../constants/bulkUtilitiesConstants'
import { useUpload } from './useUpload'
import { ConfirmationModal } from './ConfirmationModal'
import { useEffect, useRef } from 'react'

/**
 * UploadSpreadsheet Component - Upload spreadsheet, basic guide for uploading spreadsheet.
 *
 * @component
 * @returns {JSX.Element} The rendered UploadSpreadsheet component.
 */
const UploadSpreadsheet = ({ handleUploadChange }) => {
  const {
    onUpdate,
    uploadingFile,
    showConfirmationModal,
    confirmAndUpload,
    cancelUpload,
    pendingFile,
  } = useUpload(handleUploadChange)
  const dropAreaRef = useRef(null)

  //To give aria-label to the Browse button inside DropArea
  useEffect(() => {
    if (dropAreaRef.current) {
      // Find the button inside the DropArea
      const button = dropAreaRef.current.querySelector('button')
      if (button) {
        button.setAttribute('aria-label', 'Browse and Upload spreadsheet file')
      }
    }
  }, [])

  return (
    <>
      <Card
        id="card-upload-spreadsheet"
        className="hc-pa-normal hc-mt-expanded"
      >
        <h2 className="hc-fs-md font-weight-500">
          {BULK_UPDATE.UPLOAD_SPREADSHEET.HEADER_TITLE}
        </h2>
        <p className="hc-clr-grey01 hc-fs-sm hc-mt-xs hc-mb-expanded font-weight-400">
          {BULK_UPDATE.UPLOAD_SPREADSHEET.UPLOAD_CONSTRAINT}
        </p>
        {uploadingFile ? (
          <div className="hc-mt-xl hc-mb-xl">
            <Heading size={5}>
              <Spinner
                id="spinner-upload-progress"
                size="dense"
                className="hc-mt-normal hc-mh-normal"
              />
              <span style={{ position: 'relative', bottom: '4px' }}>
                {' '}
                File upload in progress...
              </span>
            </Heading>
          </div>
        ) : (
          <div ref={dropAreaRef}>
            <Input.DropArea
              id="droparea-upload-spreadsheet"
              data-testid="droparea-upload-spreadsheet"
              className="hc-pa-normal"
              dropText="Browse"
              aria-label="Upload Spreadsheet in xls or xlsx or csv format"
              accept={BULK_UPDATE.UPLOAD_SPREADSHEET.ALLOWED_TYPES}
              instructionText={
                BULK_UPDATE.UPLOAD_SPREADSHEET.UPLOAD_ACTION_GUIDE
              }
              onUpdate={onUpdate}
              fullwidth
            />
          </div>
        )}
      </Card>
      <ConfirmationModal
        isVisible={showConfirmationModal}
        onConfirm={confirmAndUpload}
        onRefuse={cancelUpload}
        file={pendingFile}
      />
    </>
  )
}

export default UploadSpreadsheet
